import { AdvancedMarker } from '@vis.gl/react-google-maps';
import type { Feature, Point } from 'geojson';

import {
  MARKER_STYLE,
  resolveAnchor,
  resolveZIndex,
} from '../markers/markerUtilities';

import { MapEditingSlice } from './drawingTypes';
import { featureToPoint } from './geometry';
import StaticTargetMarker from './StaticTargetMarker';

type EditTargetMarkersProps = {
  editing: MapEditingSlice;
};

const EditTargetMarkers = ({ editing }: EditTargetMarkersProps) => {
  const { isEditing, editMode, selected, targetViews, draft } = editing;

  // Point position of the live draft while editing a point target.
  const draftPosition =
    isEditing && editMode === 'point' && draft?.geometry.type === 'Point'
      ? featureToPoint(draft as Feature<Point>)
      : null;

  return (
    <>
      {targetViews.map(target => {
        const hideStatic = isEditing && target.isSelected;
        return hideStatic ? null : (
          <StaticTargetMarker key={target.id} target={target} />
        );
      })}
      {draftPosition && selected && (
        <AdvancedMarker
          position={draftPosition}
          zIndex={resolveZIndex(selected.type, true)}
          {...resolveAnchor(selected.type, true)}
          style={MARKER_STYLE}
        >
          {selected.activeIcon ?? selected.icon}
        </AdvancedMarker>
      )}
    </>
  );
};

export default EditTargetMarkers;
